// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__336tP","overflowing":"ReadFullNote_overflowing__hCh-b"};